export function setItem(storage: Storage, key: string, value: any) {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.log(error);
  }
}

export function getItem(storage: Storage, key: string) {
  try {
    const item = storage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  } catch (error) {
    console.log(error);
  }
}

export function removeItem(storage: Storage, key: string) {
  try {
    storage.removeItem(key);
  } catch (error) {
    console.log(error);
  }
}
